import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Footer from "components/Footers/Footer";
import Navbar from "components/Navbars/AuthNavbar";
// components

import CardLineChart from "components/Cards/CardLineChart.js";
import CardBarChart from "components/Cards/CardBarChart.js";
import ColumnChart from "components/Cards/ColumnChart";
import MonthColumnchart from "components/Cards/MonthColumnchart";
import CardStats from "components/Cards/CardStats";
import HeaderStats from "components/Headers/HeaderStats";
import ExpensesTypewisetable from "components/Cards/ExpensesTypewisetable";
import HeaderStatsForAdmin from "components/Headers/HeaderStatsForAdmin";
import HeaderStatForExpDashboard from "components/CardsForMarketing/HeaderStatForExpDashboard";
import ExpByWeekOfYear from "components/Cards/ExpByWeekOfYear";
import ExpByWeekOfYears2 from "components/Cards/ExpByWeekOfYears2";
import ColumnLineChart from "components/Cards/ColumnLineChart";

export default function Dashboard() {
  const history = useHistory();
  const [years, setYears] = useState([]);
  const [selectedGlobalYear, setSelectedGlobalYear] = useState(new Date().getFullYear());
  const [selectedGlobalMonth, setSelectedGlobalMonth] = useState(new Date().getMonth() + 1); // default: All months

  useEffect(() => {
    // Check if user is not logged in (localStorage is empty)
    if (!localStorage.getItem("userData")) {
      // Redirect to the login page
      history.push("/login");
    }
  }, [history]);

  //get userid form loca storage
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";
  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  // 🔥 Fetch Years
  useEffect(() => {
    const fetchYears = async () => {
      try {
        const res = await fetch(
          `https://expense-chart-w33t.vercel.app/api/available-years?groupId=${groupId}`
        );
        const data = await res.json();
        setYears(data.years || []);
        console.log("Available Years:", data.years);
      } catch (error) {
        console.error("Error fetching years:", error);
      }
    };

    if (groupId) {
      fetchYears();
    }
  }, [groupId]);

  return (
    <>
      <Navbar />
      <div className=" mx-auto mt-4">
        <div className="flex justify-between items-center flex-wrap gap-4" style={{ padding: "0 50px" }}>
          <h1 className="text-2xl font-bold">Expense Dashboard</h1>

          <div>
            {/* YEAR DROPDOWN */}
            <select
              value={selectedGlobalYear}
              onChange={(e) => setSelectedGlobalYear(e.target.value)}
              className="rounded-md px-3 py-2"
              style={{ width: "100px", border: "1px solid #ddd" }}
            >
              {/* <option value="All">All Years</option> */}
              {years.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
            {/* MONTH DROPDOWN */}
            <select
              value={selectedGlobalMonth}
              onChange={(e) => setSelectedGlobalMonth(e.target.value)}
              className="rounded-md px-3 py-2 ml-2"
              style={{ width: "120px", border: "1px solid #ddd" }}
            >
              <option value="All">All Months</option>
              {[
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
              ].map((month, index) => (
                <option key={month} value={index + 1}>
                  {month}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap mb-3">
        <div className="w-full  px-4">
          <HeaderStatForExpDashboard />
        </div>
      </div>
      {/* <HeaderStats/> */}

      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <ColumnLineChart years={years} selectedGlobalYear={selectedGlobalYear} />
        </div>
      </div>

      <div className="flex flex-wrap">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <CardLineChart years={years} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <CardBarChart years={years} selectedGlobalYear={selectedGlobalYear} selectedGlobalMonth={selectedGlobalMonth} />
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-8/12 mb-12 xl:mb-0 px-4">
          <ColumnChart years={years} selectedGlobalYear={selectedGlobalYear} />
        </div>
        <div className="w-full xl:w-4/12 px-4">
          <MonthColumnchart years={years} selectedGlobalYear={selectedGlobalYear} />
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <ExpensesTypewisetable years={years} selectedGlobalYear={selectedGlobalYear} />
        </div>
      </div>
      {/* <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <ExpByWeekOfYear />
        </div>
      </div> */}
      <div className="flex flex-wrap mt-4">
        <div className="w-full xl:w-12/12 mb-12 xl:mb-0 px-4">
          <ExpByWeekOfYears2 years={years} selectedGlobalYear={selectedGlobalYear} />
        </div>
      </div>
      <Footer />
    </>
  );
}
